module.exports = "https://cdn.thelire.com/ins/resource/store_free_banner_man.5699ce414098e32eb996a0e5bbedc49b.png";